const creditCardTypes = [
  { code: 'visa', name: 'VISA' },
  { code: 'mc', name: 'Master Card' },
  { code: 'discover', name: 'Discover' }
];

export default creditCardTypes;
